import { Field, Image, ImageField, RichText, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import styles from './ImageDoubleCallToAction.module.css';

type ImageDoubleCallToActionProps = ComponentProps & {
	fields: {
		CallToActionText1: Field<string>;
		CallToActionText2: Field<string>;
		Description: Field<string>;
		Image: ImageField;
		Title: Field<string>;
	};
};

export default withDatasourceCheck()<ImageDoubleCallToActionProps>(ImageDoubleCallToAction);

function ImageDoubleCallToAction(props: ImageDoubleCallToActionProps): JSX.Element {
	return (
		<div className="greyLight">
			<section className={`${styles.section} maxWidth`}>
				<div>
					<EditorHelp text="Image maxWidth 900px" />

					<Image className={styles.image} field={props.fields.Image} loading="lazy" height={600} width={900} />
				</div>

				<Text tag="h2" field={props.fields.Title} className={styles.title} />

				<div className={styles.summary}>
					<Text tag="p" field={props.fields.Description} className={styles.description} />

					<RichText tag="div" field={props.fields.CallToActionText1} className={styles.richtext} />

					<RichText tag="div" field={props.fields.CallToActionText2} className={styles.richtext} />
				</div>
			</section>
		</div>
	);
}
